import { render, staticRenderFns } from "./ListaPreciosCiudades.vue?vue&type=template&id=637cce70"
import script from "./ListaPreciosCiudades.vue?vue&type=script&lang=js"
export * from "./ListaPreciosCiudades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports